// 根据该模块下的个文件名，来做归类区分：
const en = {
	header: {
		homepage: 'Home',
		websiteManage: 'Websites',
		storeManage: 'Store',
		omniWebsiteManage: 'Store/Websites',
		websiteManageReview: 'Submit website review',
		omniWebsiteManageReview: 'Website Manage',
		storeOnboarding: 'Store Status',
		chargebackManage: 'Chargeback Manage',
		withdrawalRecord: 'Withdrawal Record',
		autoWithdrawalRecord: 'Auto-withdrawal Record',
		logisticsManage: 'Order Management',
		transactionAnalysis: 'Transaction Analysis',
		settlementStatement: 'Settlement Statement',
		accountCenter: 'Account Center',
		withdrawCenter: 'Withdrawal Account',
		identityVerification: 'Identity Verification',
		logOut: 'Log Out',
		logoutFailed: 'Sign out failed, please try again later',
		groupManagement: 'Website Group Management',
		omniGroupManagement: 'Group Management',
		fundManagement: 'Funds',
		accountBalance: 'Account Balance',
		withdrawalDetail: 'Withdrawal Detail',
		riskManagement: 'Risk',
		chargebackManagement: 'Chargeback Management',
		riskTransactionManagement: 'Risk Transaction Management',
		statement: 'Statement',
		pingpongCollection: 'PingPong Collection',
		currentsCollection: 'Currentz',
		system: 'System',
		permission: 'Permission',
		keySetting: 'Key Setting',
		transactionDetail: 'Transaction Details',
		emailMsg: 'Message Receiver Setting',
		paymentLink: 'Payment Link',
		brandList: 'Brand List',
		templateManage: 'Template Management',
		themeManage: 'Theme Management',
		modeManage: 'Mode Management',
		invoice: 'Invoice',
		statementDownload: 'Statement Download',
		transaction: 'Transactions',
		refundLog: 'Refund Log',
		transitionLog: 'Transaction Log',
		unsettledBalance: 'Unsettled Balance',
		blacklist: 'Blacklist',
		whitelist: 'Whitelist',
		disputeManage: 'Dispute Management'

	},
	webList: {
		accountChecking: 'Your bank account is under review. We will start remit for you automatically after it completes.',
		accountNotAllow: 'The payment account review failed, please deal with it as soon as possible so as not to affect your capital flow.',
		accountNoAdd: "You haven't added a bank account yet. Please add one to withdrawal your funds.",
		addNow: 'Add Now',
		addAgain: 'Resubmit',
		websiteTotal: 'You have added',
		website: 'website in total',
		websites: 'websites in total',
		approve: 'Operation',
		unbound: 'Integration',
		pending: 'Under Review',
		abnormal: 'Abnormal',
		addWebsite: 'Add a Website',
		group: 'Group',
		settleCurrency: 'Settlement Currency',
		seeDetail: 'Details',
		websiteHold: 'Sorry, the website is restricted. Please contact the customer service. You can still process the funds in your account but new orders will not be accepted.',
		websiteClose: 'Sorry, the website is closed. Please contact the customer service. You can still process the funds in your account but new orders will not be accepted.',
		websiteAbnormal: 'The status of API is abnormal. Please re-authorize to avoid affecting your business.',
		contact: 'Contact',
		reSubmit: 'Resubmit',
		modify: 'Modify',
		contactToAdd: 'Contact customer service to add new website',
		noSuportAddBySelf: 'We do not support to add websites independently now. Please contact customer service who will guide you to submit the materials. Sorry for the inconvenience.',
		pendingState: 'Under Review',
		successState: 'Approved',
		failState: 'Not approved',
		refuseState: 'Terminated',
		daysNeed: 'Please be patient',
		toBound: 'Approved,please wait patiently for API authorization',
		notFit: 'The store is closed due to compliance issues.',
		declineText: 'If you have any questions, please contact the account manager',
		declineState: 'Decline',
		reject: 'The store is rejected.',
		reSubmitPlease: 'Resubmit please',
		copySuccess: 'Copied to clipboard',
		copyFail: 'Failed to copy, please try again late',
		websiteTooMuch: 'The number of websites has reached the limit',
		websiteMoreThanfifty: 'You can add up 50 websites at most',
		riskTips1st: 'You have',
		riskTips2nt: 'risky transactions which need your review. Please confirm with the card holder(s) within 7 days, or the transaction(s) will be automatically cancelled',
		riskTipsNoPermission: ' risk orders. PingPong will review the risk and make a decision. If you have any questions, please contact us. Thank you for your understanding.',
		riskTips3rd: "risky transactions which are under PingPong's review",
		dealImmediate: 'Deal',
		view: 'View'
	},
	upload: {
		uploadField: 'Upload the document',
		uploadFail: 'Failed to upload, please try again',
		addPicture: 'Add a pic',
		reUpload: 'Re-upload',
		imgNotFit: 'Wrong picture format',
		imgToBe: 'The format of picture is limited to JPG, JPEG, PNG, BMP.',
		tip: 'Attention',
		imgMax: 'The size of uploaded image cannot exceed 1MB!',
		download: 'Download: '
	},
	global: {
		netError: 'Network request timed out, please try again later',
		netBusy: 'The network is busy, please try again later （error ',
		flowDetail: 'Flow Details',
		flowId: 'Flow Id',
		businessType: 'Business Type',
		inComingTime: 'Refund time to account',
		recordedTime: 'Incoming time',
		refundOriginTime: 'Refund to account amount',
		orderOriginAmount: 'Order original amount',
		exchangeRate: 'Exchange rate',
		refundAmount: 'Refund amount',
		recordedAmount: 'Incoming Amount',
		confirm: 'confirm',
		all: 'ALL',
		startDate: 'Start time',
		endDate: 'End time',
		selectDate: 'Select date'
	},
	wthdraw: {
		warning: [
			'According to regulatory requirements, the order info will be used as the basis for CNY settlement. Please ensure the authenticity of the information, otherwise it will affect the payment to your bank account. ',
			'If you need CNY settlement，please supply orders info first in',
			' Order Management.',
			''
		]
	},
	wthdrawManual: {
		title: 'PingPongCheckout 提现操作指南',
		tips1: '1.PingPongcheckout 商户后台-右上角【账户中心】-【提现账户】，可申请添加银行账户或虚拟账户',
		tips2: '2.申请“添加银行账户”',
		tips3: '1)	支持添加同名的对公银行账户，支持美元、欧元、英镑、港币等多种币种。',
		tips4: '2)	添加之后需及时反馈BD去审核，审核之后即可操作提现到此账户。',
		tips5: '注：不支持直接提现人民币，若有人民币结汇需求，可提现到虚拟账户（VA账户），即按照如下3“申请虚拟账户”操作。',
		tips6: '3.申请虚拟账户（也称“VA” 账户）',
		tips7: '3.1首次申请流程',
		tips8: '待实名认证及店铺资料审核通过，即可申请添加，一个店铺只能申请一个虚拟账户，结算币种可以多选。',
		tips9: '注：账户名称是自定义的，自行填写虚拟账户名称，选择账户所支持的币种，点击确认；后续要添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加即可。如第一次申请虚拟账户会跳转至PingPong收款页面进行信息填写，只需填写一次，之后再申请无需再填写，填写完成后将跳转回提现账户页面。',
		tips10: '1)	如您没有PingPong收款账户可以选择“立即注册绑定”可跳转注册页面；',
		tips11: '2)	如已拥有PingPong账户，点击页面【我已注册PingPong，立即登录绑定】，填写用户名密码登录及绑定；',
		tips12: '3)	如没有实名过，可勾选使用FI平台实名信息（即在PingPongCheckout的实名信息同步）可不再次填写；',
		tips13: '添加绑定完成将跳回提现账户页面，并且申请虚拟账户成功；',
		tips14: '4)	生成虚拟账户后在“账户中心”中会出现“PingPong收款”按钮，点击可直接跳转至PingPong收款网站进行人民币提现、供应商付款等操作。',
		tips15: '3.2非首次申请',
		tips16: '1)	在“账户中心”点击“提现账户”进入提现账户页面，在此页面可点击“申请虚拟账户”，须填写虚拟账户名称选择账户所支持的币种，点击确认，生成虚拟账户。如需添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加；',
		tips17: '2)	生成虚拟账户后在“账户中心”中会出现“PingPong收款”按钮，点击可直接跳转至PingPong收款网站进行换汇操作；',
		tips18: '注:如需添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加。',
		tips19: '4. PingPongcheckout 收单提现流程',
		tips20: '在网站【首页】或【资金管理】--【账户余额】中会显示目前可提现的金额，点击【提现】按钮，可选择要提现的银行卡或虚拟户。',
		tips21: '注意：',
		tips22: '1)	首次发起提现时，需要注意默认的提现账户，可点击右侧的”更改“，可切换提现账户；切换提现账户时，需提前创建对应的提现账户才可完成操作切换；',
		tips23: '2)	提现至虚拟户后可点击【账户中心】-【PingPong收款】跳转PingPong收款操作。',
		tips24: '5. 物流信息上传',
		tips25: '提现审核要求及人民币结汇要求，需补全商品物流信息。部分建站工具支持自动上传物流【如shopify、店匠等】，其他不支持自动上传的需手动补全物流。',
		tips26: '手动上传步骤如下： ',
		tips27: '点击【订单管理】-【上传状态】选择“未上传”，点击“导出当前结果”，将表格中的【商品名称、物流单号、物流公司、物流查询网址】补充完整，再点击“批量上传信息”将文件上传。（物流上传后大约半小时至1小时左右会同步结汇额度）',
		tips28: '6. PingPong收款平台操作流程',
		tips29: '6.1 添加提现账户',
		tips30: '点击【账户中心】-【PingPong收款】跳转PingPong收款平台，点击【账号中心】-【提现账户】，可在此页面点击“添加新账户”，添加您要提现的银行卡，添加银行卡后可对账户中的金额进行提现操作；',
		tips31: '6.2 收款提现流程',
		tips32: '通过点击【账户中心】-【PingPong收款】跳转PingPong收款平台。点击“立即提现”按钮，显示你可提现的币种金额。如有人民币提现需求的，商户在选中某个币种提现时，可看见可提现人民币的额度上限。',
		tips33: '点击“提现”跳转提现页面，可选择要提现的银行卡，根据选择银行卡支持的币种进行换汇，汇率显示在页面中，将按照汇率计算出预计到账金额，点击确认，换汇提现成功。',
		tips34: '可在提现明细中查看您提现的详情明细以及状态',
		tips35: '7. 提现常见问题',
		tips36: '(1) 提现到账时间',
		tips37: '一般1-3个工作日到账，如遇节假日会顺延。',
		tips38: '(2) 对公提现银行账户添加之后会显示审核中',
		tips39: '需反馈给对接的BD跟进审核，如未反馈，会一直显示审核中，无法进行下一步操作。',
		tips40: '(3) 提现收费',
		tips41: '提现按次/笔收费，具体费用参考签约的合同或联系对接BD。',
		tips42: '(4) 提现币种',
		tips43: '提现支持币种以商户后台实际展示币种为准，如有特殊需求，可提前与对接BD沟通。'
	},
	common: {
		cancel: 'Cancel',
		confirm: 'Confirm'
	}
}

export default en
